const $$splitComponentImporter = () => import('/home/runner/work/graph-it/graph-it/apps/graphit/src/routes/_authed/cartographies/$id/classic.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { cartographyQueryOptions } from '~/queries/cartography';
export const Route = createFileRoute('/_authed/cartographies/$id/classic')({
  loader: ({
    context,
    params
  }) => context.queryClient.ensureQueryData(cartographyQueryOptions(params.id)),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type GraphNodePosition = {
  x: number;
  y: number;
};